import { client as request } from "../../api/request";

export interface Construction {
  id: string;
  serviceTaskTypeId: number;
  name: string;
  shortName: string;
}

/**
 * 工事内容を取得する
 */
export async function getConstruction(id: string = "") {
  const construxtion = await request.get("get_m_construction.php", {
    id
  });
  return construxtion.ConstructionList;
}

export async function getConstructionEdit(id: string = "") {
  const construxtion = await request.get("get_m_construction.php", {
    id
  });
  return construxtion.ConstructionList[0];
}

/**
 * 工事内容を保存する
 */
export async function saveConstruction(construction: FormData) {
  const res = await request.post("save_m_construction.php", construction);
  return res.constructionId;
}

/**
 * 工事内容を削除する
 */
export async function deleteConstruction(id: any) {
  await request.post("delete_m_construction.php", {}, { id });
}
